import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Dropdown, ButtonGroup, Button } from 'react-bootstrap';

const ExportButton = ({
                        columns = [],
                        rows = [],
                        filename = 'eksport',
                        excludeFields = ['actions']
                      }) => {
  const extractText = (value) => {
    if (typeof value === 'string' || typeof value === 'number') {
      return String(value);
    } else if (React.isValidElement(value)) {
      return React.Children.toArray(value.props.children)
        .map(extractText)
        .join(' ');
    } else if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value);
    }
    return '';
  };

  const getExportDataWithLabels = () => {
    const exportColumns = columns
      .filter(
        (col) => !excludeFields.includes(col.field) && col.export !== false
      )
      .map((col) => ({
        field: col.field,
        label: col.label || col.field,
        exportValue: col.exportValue
      }));

    return rows.map((row) => {
      const flatRow = {};
      exportColumns.forEach(({ field, label, exportValue }) => {
        const rawValue =
          typeof exportValue === 'function' ? exportValue(row.raw) : row[field];
        flatRow[label] = extractText(rawValue);
      });
      return flatRow;
    });
  };

  const exportToExcel = () => {
    const data = getExportDataWithLabels();
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dane');
    const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, `${filename}_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const exportToCSV = () => {
    const data = getExportDataWithLabels();
    const worksheet = XLSX.utils.json_to_sheet(data);
    const csv = XLSX.utils.sheet_to_csv(worksheet);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${filename}_${new Date().toISOString().slice(0, 10)}.csv`);
  };

  return (
    <Dropdown as={ButtonGroup} drop={'start'}>
      <Button variant="outline-success" size="sm" onClick={exportToExcel}>
        Eksportuj
      </Button>
      <Dropdown.Toggle split variant="outline-success" size="sm" />
      <Dropdown.Menu>
        <Dropdown.Item onClick={exportToExcel}>Excel (.xlsx)</Dropdown.Item>
        <Dropdown.Item onClick={exportToCSV}>CSV (.csv)</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ExportButton;
